import GlobalHeader from './GlobalHeader';

export default function PageLayout({ children, headerThreshold }) {
  return (
    <>
      <GlobalHeader hideThreshold={headerThreshold} hamburgerOnly />
      <main>{children}</main>
    </>
  );
}
